//
//
//
//
//
//

export default {
  name: 'DownloadMenuPage',

  layout: 'page',
}
